<template>
    <section v-if="elemVisible" class="global-popup" :class="elemClass">
        <div class="container">
            <div class="column-wrapper">
                <slot></slot>
            </div>
        </div>

        <div class="background-el" @click="hideElem"></div>
    </section>
</template>

<script>
import { useAuthenticationData } from '@/composables/useAuthenticationData'
export default {
    props: ['elemClass', 'elemVisible'],
    emits: ['hidePopupEl'],
    data() {
        return {
            //hideCurrentElem: false
        }
    },
    computed: {
        isAuthenticated() {
            return useAuthenticationData().data.value.isAuthenticated
        }
    },
    watch: {
        $route() {
            this.hideElem()
        }
    },
    // components: {
    // 	LoginPopup,
    // 	ForgotPasswordPopup
    // },
    created() { },
    methods: {
        hideElem() {
            this.$emit('hidePopupEl', 'false')
        }
    }
}
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
